module.exports = __webpack_public_path__ + "media/images/brand/app_symbol_250-34181c99bfad1d13ca50e3a1f3566372.png";